import { Engine } from '../../core/Engine';
import { ReorderElementCommand } from '../Commands';

export class ReorderElementCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: ReorderElementCommand) {
        this.engine.reorderElement(command.uuid, command.targetIndex);
    }
}
